import { createSlice } from '@reduxjs/toolkit';

export interface ProcurementSchedule {
  releaseRequests: string;
  receiveProposals: string;
  makeAwards: string;
  negotiateContracts: string;
  executeContracts: string;
}

const initialState: ProcurementSchedule = {
  releaseRequests: '',
  receiveProposals: '',
  makeAwards: '',
  negotiateContracts: '',
  executeContracts: '',
};

export const ProcurementScheduleSlice = createSlice({
  name: 'procurementScheduleSliceInfo',
  initialState,
  reducers: {
    setProcurementSchedule(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
});

export const { setProcurementSchedule } = ProcurementScheduleSlice.actions;

export default ProcurementScheduleSlice.reducer;
